/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import { Flex, Link, Heading, Text } from '@chakra-ui/react'
import SideNav from '../../components/SideNav'
import Footer from '../../components/Footer'
import Wrap from '../../components/Wrap'

const Page: React.FC = () => {
  return (
    <>
      <Wrap id="home" bottomHR={false} justifyContent="center">
        <Flex
          flexDir={{ base: 'column' }}
          py="120px"
          gap="20px"
          w="100%"
          maxW={{ base: '500px', xl: 'initial' }}
          justifyContent="space-between"
          minH="calc(100vh - 60px)"
        >
          <Heading as="h1" size="xl" mb={4}>
            Privacy Policy for Reactvts
          </Heading>

          <Text as="p" fontSize="lg" mb={4}>
            Last updated: September 13, 2023
          </Text>

          <Heading as="h2" size="lg" mb={4}>
            Introduction
          </Heading>

          <Text as="p" fontSize="md" mb={4}>
            Welcome to Reactvts ("we," "our," or "us"). We are committed to
            protecting your privacy and providing you with a safe and secure
            online experience. This Privacy Policy explains how we collect, use,
            disclose, and safeguard your information when you visit our website.
          </Text>

          <Text as="p" fontSize="md" mb={4}>
            By accessing or using our website, you consent to the practices
            described in this Privacy Policy. If you do not agree with this
            Privacy Policy, please do not use our website.
          </Text>

          <Heading as="h2" size="lg" mb={4}>
            Information We Collect
          </Heading>

          <Text as="p" fontSize="md" mb={4}>
            We only collect information that is necessary to provide you with
            the best possible experience on our website. The primary type of
            information we collect is non-personally identifiable information
            through Google Analytics 4 (GA4). This information includes:
          </Text>

          <Text as="ol" fontSize="md" ml={4} mb={4}>
            <li>
              Usage Information: We collect data about how you interact with our
              website. This may include your IP address, browser type, operating
              system, device information, and the pages you visit.
            </li>
            <li>
              Cookies and Tracking Technologies: We use cookies and other
              tracking technologies to collect information about your browsing
              behavior on our website. Cookies are small text files that are
              stored on your device. You can manage your cookie preferences
              through your browser settings.
            </li>
          </Text>

          <Heading as="h2" size="lg" mb={4}>
            How We Use Your Information
          </Heading>

          <Text as="p" fontSize="md" mb={4}>
            The information collected through GA4 is used for statistical
            analysis and to improve the quality of our website. We do not use
            this information to personally identify you or track your activities
            beyond our website. Our use of this information includes:
          </Text>

          <Text as="ol" fontSize="md" ml={4} mb={4}>
            <li>
              Website Improvement: We use the collected data to analyze user
              behavior and preferences, helping us make improvements to our
              website's content and functionality.
            </li>
            <li>
              Analytics: We use GA4 to generate aggregated and anonymized
              reports on website traffic and user interactions.
            </li>
            <li>
              Security: We may use information to protect the security and
              integrity of our website, as well as to investigate and prevent
              fraud or abuse.
            </li>
          </Text>

          <Heading as="h2" size="lg" mb={4}>
            Disclosure of Your Information
          </Heading>

          <Text as="p" fontSize="md" mb={4}>
            We do not sell, rent, trade, or otherwise disclose your
            non-personally identifiable information collected through GA4 to
            third parties, except as described in this Privacy Policy. We may
            disclose your information in the following circumstances:
          </Text>

          <Text as="ol" fontSize="md" ml={4} mb={4}>
            <li>
              Legal Compliance: We may disclose your information when required
              by law or in response to a valid legal request.
            </li>
            <li>
              Service Providers: We may share your information with third-party
              service providers who assist us in operating our website and
              providing services, subject to confidentiality agreements.
            </li>
          </Text>

          <Heading as="h2" size="lg" mb={4}>
            Your Choices
          </Heading>

          <Text as="p" fontSize="md" mb={4}>
            You can manage your cookie preferences through your browser
            settings. You can also opt-out of Google Analytics tracking by
            visiting the Google Analytics Opt-Out Browser Add-on.
          </Text>

          <Heading as="h2" size="lg" mb={4}>
            Children's Privacy
          </Heading>

          <Text as="p" fontSize="md" mb={4}>
            Our website is not directed to children under the age of 13. We do
            not knowingly collect personal information from children. If you are
            a parent or guardian and believe that your child has provided us
            with personal information, please contact us, and we will take steps
            to remove such information.
          </Text>

          <Heading as="h2" size="lg" mb={4}>
            Changes to This Privacy Policy
          </Heading>

          <Text as="p" fontSize="md" mb={4}>
            We reserve the right to update this Privacy Policy at any time. We
            will notify you of any changes by posting the updated Privacy Policy
            on this page with a new "Last Updated" date. We encourage you to
            review this Privacy Policy periodically.
          </Text>

          <Heading as="h2" size="lg" mb={4}>
            Contact Us
          </Heading>

          <Text as="p" fontSize="md" mb={4}>
            If you have any questions, concerns, or requests related to this
            Privacy Policy or our privacy practices, please contact us at{' '}
            <Link href="mailto:info@reactvts.com">Info@Reactvts.com</Link>.
          </Text>

          <Text as="p" fontSize="md" mb={8}>
            Thank you for visiting Reactvts. Your privacy is important to us,
            and we are committed to safeguarding your information.
          </Text>
        </Flex>
      </Wrap>
      <SideNav />
      <Footer />
      <style>
        {`@keyframes cardWiggle {
            0%, 100% {
              transform: perspective(900px)  rotateY(-16deg);
            }
            50% {
              transform: perspective(900px)  rotateY(-8deg);
            }
          }
          `}
      </style>
    </>
  )
}

export { Page }
